import MenuCategories from "../MenuCategories";
import React from "react";
import styles from "./Menu.module.css";
import {Outlet} from "react-router-dom";
import {useAppSelector} from "../../lib/hooks";

export default function Menu() {
    // TODO: #261 - support purchasing gift cards as part of regular order
    const isGiftCardsOrder = useAppSelector(
        (state) =>
            !!state.pos.currentOrder.giftCards.addFunds.length ||
            !!state.pos.currentOrder.giftCards.purchase.length,
    );
    const isTraining = useAppSelector((state) => state.pos.station.isTraining);

    const assignedTill = useAppSelector(
        (state) => state.pos.station.assignedTill,
    );
    const trainingModeAssignedTill = useAppSelector(
        (state) => state.pos.station.trainingModeAssignedTill,
    );
    const tillAssignmentSkipped = useAppSelector(
        (state) => state.pos.station.tillAssignmentSkipped,
    );
    const isTillAssignmentRequired = isTraining
        ? trainingModeAssignedTill === -1
        : assignedTill === -1 && !tillAssignmentSkipped;

    return (
        <>
            <MenuCategories
                className={styles.menuCategories}
                disabled={isTillAssignmentRequired || isGiftCardsOrder}
            />
            <div className={styles.menuCategoryItems}>
                <Outlet />
            </div>
        </>
    );
}
